import React, { useEffect, useState } from "react";
import "./SharedFilesView.css";
import MultimediaHelper from "../Multimedia/MultimediaHelper";
import { file } from "jszip";
/**
 * SharedFilesPage
 *
 * Props:
 * - initialFiles: Array of objects with { title, description, type, url, webPath }
 */
export default function SharedFilesPage({ initialFiles }) {
  const [horses, setHorses] = useState([]);

  const fetchHorses = async () => {
    const horses = window.DataStorage.getAllHorses();
    if (!horses || horses.length === 0) {
      setTimeout(fetchHorses, 1000);
      return;
    }

    setHorses(horses);
  };

  useEffect(() => {
    fetchHorses();
  }, [initialFiles]);

  const makeUploadList = async (sharedItems) => {
    const request_origin = window.location.href;

    // 2) Turn each ShareItem into your UploadFileRecord
    const files = sharedItems.map(function (si) {
      var isImage = si.type.indexOf("image/") === 0;
      return {
        fileName: si.title,
        mimeType: si.type,
        media_path: si.url, // native URI to be fetched by your plugin
        preview: si.webPath, // you can later use this as a thumbnail
        type: isImage
          ? MultimediaHelper.TYPE_IMAGE
          : MultimediaHelper.TYPE_VIDEO,
      };
    });
    return files;
  };
  const onClickHorse = async (horse) => {
    const makeAddHorseLink = (horseId) => {
      return `${window.location.origin}${window.location.pathname}#addHorsePage?id=${horseId}`;
    };

    console.log("Horse clicked", horse);
    console.log("Initial data", initialFiles);
    const href = makeAddHorseLink(horse.id);
    const upload_list = await makeUploadList(initialFiles);

    console.log("Upload list", upload_list);

    const helper = new MultimediaHelper();

    console.log("Horse id", horse.id);
    console.log("Horse user id", horse.userid);

    helper.setFinishCallback(() => {});

    helper.setProgressCallback(() => {});
    helper.setRefreshCallback(() => {});
    helper.setCurrentSettings("Multimedia", horse.id, horse.userid, true, "");

    helper.addToUploadQueue(upload_list);

    window.Managers.self.onEditHorse(horse.id, undefined, {
      filesToBeUploaded: upload_list,
    });

    document.getElementById("sharedFilesPage").style.display = "none";
    window.$("#bottomMenu").show();

    console.log("Upload list", upload_list);
  };
  return (
    <div className="shared-files-page">
      <div className="shared-files-page--content">
        {horses.map((horse) => {
          let imgSrc = "img/horselogo.png";
          if (horse.LogoFile != null) {
            const horseLogo =
              horse.LogoFile != null
                ? horse.LogoFile.split(".jpg")[0] + "-thumb.jpg"
                : "";
            imgSrc = window.DataGate.baseurl + horseLogo;
          }

          return (
            <div key={horse.id} onClick={() => onClickHorse(horse)}>
              <div
                className="homeHImage"
                style={{
                  backgroundImage: `url(${imgSrc})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
              <br />
              <span>${horse.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
